module.exports = __webpack_public_path__ + "img/cover.01b4f7a6.jpg";